import { useState } from "react";
import { SearchInput } from "../ProductListing/Filters";
import Spin from "../Spinner/Spinner";
import { CreateEditUserDialog } from "./CreateUserDialog";
import { useUsers } from "./hooks/useUsers";
import styles from "./Users.module.css";
import { useNavigate } from "react-router-dom";
import { FaPencilAlt } from "react-icons/fa";

const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

const formatTime = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${hours}:${minutes}`;
};

export const Users = () => {
  const navigate = useNavigate();
  const {
    users,
    search,
    loading,
    pagination,
    page,
    setPage,
    handleSearch,
    createUser,
    updateUser,
  } = useUsers();
  const [showCreateDialog, setShowCreateDialog] = useState(false);
  const [editingUser, setEditingUser] = useState(null);

  if (loading) {
    return <Spin />;
  }
  return (
    <div className={styles.container}>
      <h1>Users</h1>
      <div className={styles.searchContainer}>
        <SearchInput value={search} onChange={handleSearch} />
        <button
          className={styles.button}
          onClick={() => setShowCreateDialog(true)}
        >
          Create New User
        </button>
      </div>

      <div className={styles.usersTableContainer}>
        {(!users || users.length === 0) && (
          <p className={styles.noUsers}>No users found</p>
        )}

        {users && users.length > 0 && (
          <table className={styles.usersTable}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Company Name</th>
                <th>Email</th>
                <th>Active Carts</th>
                <th>Phone</th>
                <th>Created At</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user._id}>
                  <td className={styles.nameCell}>
                  <button
                      type="button"
                      className={styles.editButton}
                      onClick={() => setEditingUser(user)}
                      aria-label="Edit user"
                    >
                      <FaPencilAlt />
                    </button>
                    <span>{user?.name ?? "-"}</span>
                  </td>
                  <td>{user?.companyName ?? "-"}</td>
                  <td>{user?.email ?? "-"}</td>
                  <td>{user?.cartCount ?? 0}</td>
                  <td>{user?.phone || "-"}</td>
                  <td>{formatDate(user?.createdAt) ?? "-"}</td>
                  <td className={styles.viewDetailsCell}>
                    <button
                      type="button"
                      className={styles.viewDetailsButton}
                      onClick={() => navigate(`/users/${user._id}/carts`)}
                    >
                      View Carts
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <CreateEditUserDialog
        show={showCreateDialog || !!editingUser}
        onClose={() => {
          setShowCreateDialog(false);
          setEditingUser(null);
        }}
        onSubmit={async (data) => {
          if (editingUser) {
            const payload = { ...data };
            if (payload.password === "") delete payload.password;
            await updateUser(editingUser._id, payload);
            setEditingUser(null);
          } else {
            await createUser(data);
          }
        }}
        isEditing={!!editingUser}
        initialData={editingUser}
      />

      {pagination.totalPages > 1 && (
        <div className={styles.paginationContainer}>
          <button
            type="button"
            className={styles.pageButton}
            disabled={page <= 1}
            onClick={() => page > 1 && setPage(page - 1)}
          >
            Previous
          </button>
          <span className={styles.pageInfo}>
            Page {pagination.currentPage || page} of {pagination.totalPages}
          </span>
          <button
            type="button"
            className={styles.pageButton}
            disabled={page >= pagination.totalPages}
            onClick={() => page < pagination.totalPages && setPage(page + 1)}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};
